import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function StrategicLeadershipThemes({
  strategicLeadershipThemes = [],
  compView,
}) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "theme", label: "Theme" },
        { key: "timeline", label: "Timeline" },
        { key: "impact", label: "Impact" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "theme", label: "Theme" },
        { key: "timeline", label: "Timeline" },
        { key: "impact", label: "Impact" },
        { key: "strategic_note", label: "Strategic Note" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  // const dummyData = [
  //   {
  //     theme: {
  //       value: "Digital Transformation",
  //       source: "https://placeholder.source.com",
  //       data_type: "Strategy",
  //       confidence_score: 0.92,
  //       reasoning: "Part of the 2023 growth roadmap.",
  //     },
  //     timeline: {
  //       value: "2023 - 2025",
  //       source: "https://placeholder.source.com",
  //       data_type: "Period",
  //       confidence_score: 0.95,
  //       reasoning: "Planned over a two-year timeframe.",
  //     },
  //     impact: {
  //       value: "High",
  //       source: "https://placeholder.source.com",
  //       data_type: "Impact",
  //       confidence_score: 0.89,
  //       reasoning: "Expected to impact all business units.",
  //     },
  //     strategic_note: {
  //       value: "Leverage AI for improved customer experience.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.85,
  //       reasoning: "Based on strategic planning documents.",
  //     },
  //     theme_positive_insight: {
  //       value: "Digital Transformation",
  //       source: "https://placeholder.source.com",
  //       data_type: "Strategy",
  //       confidence_score: 0.92,
  //       reasoning: "Part of the 2023 growth roadmap.",
  //     },
  //     theme_negative_insight: {
  //       value: "Digital Transformation",
  //       source: "https://placeholder.source.com",
  //       data_type: "Strategy",
  //       confidence_score: 0.92,
  //       reasoning: "Part of the 2023 growth roadmap.",
  //     },
  //     theme_recent_development: {
  //       value: "Digital Transformation",
  //       source: "https://placeholder.source.com",
  //       data_type: "Strategy",
  //       confidence_score: 0.92,
  //       reasoning: "Part of the 2023 growth roadmap.",
  //     },
  //     timeline_positive_insight: {
  //       value: "2023 - 2025",
  //       source: "https://placeholder.source.com",
  //       data_type: "Period",
  //       confidence_score: 0.95,
  //       reasoning: "Planned over a two-year timeframe.",
  //     },
  //     timeline_negative_insight: {
  //       value: "2023 - 2025",
  //       source: "https://placeholder.source.com",
  //       data_type: "Period",
  //       confidence_score: 0.95,
  //       reasoning: "Planned over a two-year timeframe.",
  //     },
  //     timeline_recent_development: {
  //       value: "2023 - 2025",
  //       source: "https://placeholder.source.com",
  //       data_type: "Period",
  //       confidence_score: 0.95,
  //       reasoning: "Planned over a two-year timeframe.",
  //     },
  //     impact_positive_insight: {
  //       value: "High",
  //       source: "https://placeholder.source.com",
  //       data_type: "Impact",
  //       confidence_score: 0.89,
  //       reasoning: "Expected to impact all business units.",
  //     },
  //     impact_negative_insight: {
  //       value: "High",
  //       source: "https://placeholder.source.com",
  //       data_type: "Impact",
  //       confidence_score: 0.89,
  //       reasoning: "Expected to impact all business units.",
  //     },
  //     impact_recent_development: {
  //       value: "High",
  //       source: "https://placeholder.source.com",
  //       data_type: "Impact",
  //       confidence_score: 0.89,
  //       reasoning: "Expected to impact all business units.",
  //     },
  //     strategic_note_positive_insight: {
  //       value: "Leverage AI for improved customer experience.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.85,
  //       reasoning: "Based on strategic planning documents.",
  //     },
  //     strategic_note_negative_insight: {
  //       value: "Leverage AI for improved customer experience.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.85,
  //       reasoning: "Based on strategic planning documents.",
  //     },
  //     strategic_note_recent_development: {
  //       value: "Leverage AI for improved customer experience.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.85,
  //       reasoning: "Based on strategic planning documents.",
  //     },
  //   },
  //   {
  //     theme: {
  //       value: "Market Expansion",
  //       source: "https://placeholder.source.com",
  //       data_type: "Strategy",
  //       confidence_score: 0.87,
  //       reasoning: "Initiated in Q1 2023.",
  //     },
  //     timeline: {
  //       value: "2023 - 2026",
  //       source: "https://placeholder.source.com",
  //       data_type: "Period",
  //       confidence_score: 0.91,
  //       reasoning: "Expansion planned across three years.",
  //     },
  //     impact: {
  //       value: "Medium",
  //       source: "https://placeholder.source.com",
  //       data_type: "Impact",
  //       confidence_score: 0.88,
  //       reasoning: "Will affect select regions initially.",
  //     },
  //     strategic_note: {
  //       value: "Focus on Europe and APAC.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Based on market research analysis.",
  //     },
  //   },
  //   {
  //     theme: {
  //       value: "Product Innovation",
  //       source: "https://placeholder.source.com",
  //       data_type: "Strategy",
  //       confidence_score: 0.93,
  //       reasoning: "High priority for 2024.",
  //     },
  //     timeline: {
  //       value: "2024 - 2027",
  //       source: "https://placeholder.source.com",
  //       data_type: "Period",
  //       confidence_score: 0.9,
  //       reasoning: "Projected to take three years for development.",
  //     },
  //     impact: {
  //       value: "Very High",
  //       source: "https://placeholder.source.com",
  //       data_type: "Impact",
  //       confidence_score: 0.95,
  //       reasoning: "Expected to lead to significant market differentiation.",
  //     },
  //     strategic_note: {
  //       value: "Focus on sustainable product lines.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.85,
  //       reasoning: "Based on sustainability reports and consumer demand.",
  //     },
  //   },
  //   {
  //     theme: {
  //       value: "Operational Efficiency",
  //       source: "https://placeholder.source.com",
  //       data_type: "Strategy",
  //       confidence_score: 0.91,
  //       reasoning: "Key initiative for reducing costs.",
  //     },
  //     timeline: {
  //       value: "2023 - 2024",
  //       source: "https://placeholder.source.com",
  //       data_type: "Period",
  //       confidence_score: 0.92,
  //       reasoning: "Planned for a one-year implementation period.",
  //     },
  //     impact: {
  //       value: "High",
  //       source: "https://placeholder.source.com",
  //       data_type: "Impact",
  //       confidence_score: 0.88,
  //       reasoning: "Will improve bottom-line profitability.",
  //     },
  //     strategic_note: {
  //       value: "Optimize supply chain operations.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Based on internal operational audit findings.",
  //     },
  //   },
  // ];

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(
      strategicLeadershipThemes
    );
    setTabData(transformed);
    // setTableBelowDescription(
    //   <ParsedTextWithLinks
    //     text={
    //       strategicLeadershipThemes?.[0]?.response[
    //         "distribution_positioning_summary"
    //       ] || ""
    //     }
    //   />
    // );
  }, [strategicLeadershipThemes]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Strategic Leadership Themes"
      data={tabData}
      metrics={columns}
      rowIdentifier="theme"
      actions={actions}
    />
  );
}

export default StrategicLeadershipThemes;
